import React from "react";
import Reveal from "./Reveal";
import { ASSETS } from "../mock";

const Founder = () => {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="bg-white py-24 lg:py-32 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-full h-full border border-[#B88A3B]/30" />
            <div className="relative overflow-hidden aspect-[4/5]">
              <img
                alt="Negar Sheikh, founder of Marbella Consulting"
                data-testid="founder-photo"
                className="w-full h-full object-cover object-[55%_center] hover:scale-105 transition-transform duration-700"
                src={ASSETS.founder}
              />
            </div>
          </div>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.15}>
          <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
            Meet the Founder
          </p>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6">
            Negar <span className="gold-text italic">Sheikh</span>
            <span
              dir="rtl"
              lang="fa"
              className="block text-left font-serif-lux text-2xl md:text-3xl text-[#B88A3B]/85 mt-4 not-italic"
            >
              نگار شیخ
            </span>
          </h2>
          <div className="hairline my-10 max-w-xs" />
          <p className="text-base md:text-lg text-[#18324F]/75 leading-relaxed max-w-2xl">
            Negar Sheikh was born in Tehran and, at a young age, moved to Spain
            with her family, where she has lived all her life. She has now
            established a strong name and extensive experience in the Marbella,
            Estepona &amp; Benahávís areas.
          </p>
          <p className="text-base md:text-lg text-[#18324F]/75 leading-relaxed max-w-2xl mt-6">
            She has over 20 years of experience in property consultancy and has
            also worked with leading Spanish banks, including Santander, as a
            mortgage advisor. For the last three years, she has also been working
            as a bespoke concierge, curating tailor-made stays and experiences
            for her clients.
          </p>
          <a
            href="#contact"
            className="inline-block mt-10 border border-[#B88A3B]/60 text-[#0B284A] px-8 py-4 uppercase tracking-[0.2em] text-sm hover:border-[#B88A3B] hover:text-[#B88A3B] transition-colors duration-300"
          >
            Speak with Negar
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default Founder;
